var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGps28 = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.14646 4.14646C4.27836 4.01456 4.47271 3.96705 4.65058 4.02322L23.6506 10.0232C23.8488 10.0858 23.9876 10.2644 23.9992 10.4719C24.0109 10.6794 23.893 10.8725 23.7031 10.9569L14.8788 14.8788L10.9569 23.7031C10.8725 23.893 10.6794 24.0109 10.4719 23.9992C10.2644 23.9876 10.0858 23.8488 10.0232 23.6506L4.02322 4.65058C3.96705 4.47271 4.01456 4.27836 4.14646 4.14646ZM5.26635 5.26635L10.5793 22.0906L14.0431 14.2969C14.0934 14.1838 14.1838 14.0934 14.2969 14.0431L22.0906 10.5793L5.26635 5.26635Z",
  fill: "currentColor"
})));
export default SvgGps28;